export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, hint, accent = "text-primary" }) {
  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-sm transition-shadow h-full">
      <div className="flex items-center justify-between">
        <p className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground">{label}</p>
        {Icon && <Icon className={`h-5 w-5 ${accent}`} strokeWidth={1.5} />}
      </div>
      <p className="mt-3 font-heading text-3xl font-semibold">{value}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, desc, action }) {
  return (
    <div className="bg-card border border-dashed border-border rounded-xl p-12 text-center">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground mx-auto" strokeWidth={1.3} />}
      <h3 className="mt-4 text-lg font-medium">{title}</h3>
      {desc && <p className="text-muted-foreground mt-1 max-w-sm mx-auto">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Loading() {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="h-8 w-48 bg-muted rounded" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-28 bg-muted rounded-xl" />)}
      </div>
      <div className="h-64 bg-muted rounded-xl" />
    </div>
  );
}
